import styled from "styled-components";

export const ContainerPainelConsults = styled.div<{status?: boolean}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  height: 90px;
  background: ${(props) => props.status ? "#E7F3FD" : "#fafafa"} ;
  border-radius: 8px;
  margin-top: 5px;
`;

export const NamePacient = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin-left: 10px;
`;

export const DivName = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
`;

export const DivHorario = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  font-weight: 500;
  font-size: 18px;

  width: 122px;
  height: 20px;

  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  color: #0a5190;
`;

export const DivTipo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  color: #101828;
  font-weight: 500;
`;

export const DivProntuario = styled.div`
  width: 125px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  color: #0A5190;
  padding: 0 10px;
  border-radius: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    color: #083b6b;
    background-color: rgba(10, 81, 144, 0.08);
    transform: translateX(2px);

    svg {
      transform: translateX(3px);
    }
  }

  svg {
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
